import API_URL from "../config/api";

import { deleteCookie, setCookie } from "./cookies";
import {
  clearStoredImpersonation,
  getStoredAdminToken,
  isAdminDashboardToken,
  restoreStoredAdminSession,
} from "./impersonation";
import { replaceLocation } from "./navigation";

export const validateStoredAdminToken = async (
  adminToken,
  baseURL = API_URL
) => {
  const response = await fetch(`${baseURL}/v1/dashboard/validate-token`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${adminToken}`,
    },
  });

  if (!response.ok) {
    throw new Error("Invalid admin token");
  }

  return response.json().catch(() => ({ status: 200 }));
};

export const recoverStoredAdminSession = async ({
  baseURL = API_URL,
  redirect = true,
  validateToken,
} = {}) => {
  const adminToken = getStoredAdminToken();

  if (!isAdminDashboardToken(adminToken)) return null;

  if (validateToken) {
    await validateToken(adminToken);
  } else {
    await validateStoredAdminToken(adminToken, baseURL);
  }

  const restored = restoreStoredAdminSession();

  if (!restored) return null;

  setCookie("authToken", restored.adminToken, 30);

  if (redirect) {
    replaceLocation(restored.returnPath);
  }

  return restored;
};

export const clearAuthAndImpersonationForLogin = ({ redirect = true } = {}) => {
  localStorage.removeItem("authToken");
  deleteCookie("authToken");
  clearStoredImpersonation();

  if (redirect) {
    replaceLocation("/login");
  }
};
